import React, { useState, useEffect } from 'react';
import {
  ButtonHLPure,
  CheckBoxHLPure,
  TooltipHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from '../../../pures';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { profileIconDefault } from '../../../../assets/logos/icons';
import UserInvitedService from '../../../../services/user-invited.service'
import './user-administration-role-assign.view.css';

const UserAdministrationRoleAssignView = ({
  hideShowDetails,
  selectedUser,
  token,
  rolesBySignatureProfile,
  rolesByEmailUser,
  saveRolesAndProfilesForUser,
  showDetailComponent,
  toggleShowDetailComponent,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
  emailAdmin,
  toggleCompleteCloseDialog
}) => {
  const [checkedSuperAdministrator, setCheckedSuperAdministrator] =
    useState(false);
  const [checkedStateHelpDesk, setCheckedStateHelpDesk] = useState();
  const [checkedStateContrato, setCheckedStateContrato] = useState();
  const [checkedStateBoveda, setCheckedStateBoveda] = useState();
  const [checkedStateProfiles, setCheckedStateProfiles] = useState();
  const [checkedStateProfilesOrg, setCheckedStateProfilesOrg] = useState();
  const [checkedStateAccessType, setCheckedStateAccessType] = useState([]);
  const [checkboxDisabled, setCheckboxDisabled] = useState(
    checkedSuperAdministrator
  );
  const [showNoPasswordConfirm, setShowNoPasswordConfirm] = useState(false);
  const [pendingNoPasswordChange, setPendingNoPasswordChange] = useState(null);
  const { t } = useTranslation();
  const [pendingActions, setPendingActions] = useState({
    resendInvitation: false
  })

  useEffect(() => {
    if (!rolesByEmailUser || !rolesByEmailUser.roleHibou) return;
    const isChecked = rolesByEmailUser?.roleHibou.id === 5;
    setCheckedSuperAdministrator(isChecked);
    setCheckboxDisabled(isChecked);
  }, [rolesByEmailUser]);

  const setDefaultCheckedValuesContrato = () => {
    let finalArrContrato = [];
    rolesBySignatureProfile.rolesContrato
      .sort((a, b) => {
        return a.id - b.id;
      })
      .map((rolContrato) => {
        let rolContratNameDefault = (
          (rolesByEmailUser || {}).roleContract || {}
        ).name;
        return finalArrContrato.push({
          name: rolContrato.name,
          checkedValue:
            rolContratNameDefault === rolContrato.name ? true : false,
          id: rolContrato.id,
          key: rolContrato.key,
        });
      });
    setCheckedStateContrato(finalArrContrato);
  };

  const setDefaultCheckedValuesHelpDesk = () => {
    let finalArrHelpDesk = [];
    rolesBySignatureProfile.rolesHelpDesk
      .sort((a, b) => {
        return a.id - b.id;
      })
      .map((rolHelpDesk) => {
        let rolContratNameDefault = (
          (rolesByEmailUser || {}).roleHelpDesk || {}
        ).name;
        return finalArrHelpDesk.push({
          name: rolHelpDesk.name,
          checkedValue:
            rolContratNameDefault === rolHelpDesk.name ? true : false,
          id: rolHelpDesk.id,
          key: rolHelpDesk.key,
        });
      });
    setCheckedStateHelpDesk(finalArrHelpDesk);
  };

  const setDefaultCheckedValuesBoveda = () => {
    let finalArrBoveda = [];
    rolesBySignatureProfile.rolesBoveda.map((rolBoveda) => {
      let rolBovedaNameDefault = ((rolesByEmailUser || {}).roleBoveda || {})
        .name;
      return finalArrBoveda.push({
        name: rolBoveda.name,
        checkedValue: rolBovedaNameDefault === rolBoveda.name ? true : false,
        id: rolBoveda.id,
        key: rolBoveda.key,
      });
    });
    setCheckedStateBoveda(finalArrBoveda);
  };

  const setDefaultCheckedValuesSignatureProfile = () => {
    let finalArrProfile = [];
    rolesBySignatureProfile.signaturesProfile.map((profile) => {
      return finalArrProfile.push({
        name: profile.name,
        checkedValue:
          rolesByEmailUser.signaturerProfiles
            ?.map(function (roleProfile) {
              return roleProfile?.signatureProfile.name === profile.name
                ? true
                : false;
            })
            .filter((value) => (value ? value : false))[0] ?? false,
        id: profile.id,
      });
    });
    setCheckedStateProfiles(finalArrProfile);
    setCheckedStateProfilesOrg(finalArrProfile);
  };

  const setDefaultCheckedValuesAccessType = () => {
    let finalArrAccessType = [];
    if (rolesBySignatureProfile.rolesAccessType) {
      rolesBySignatureProfile.rolesAccessType.map((accessType) => {
        let roleAccessTypeDefault = ((rolesByEmailUser || {}).roleAccessType || {}).name;
        return finalArrAccessType.push({
          name: accessType.name,
          checkedValue: roleAccessTypeDefault === accessType.name ? true : false,
          id: accessType.id,
          key: accessType.key,
        });
      });
    }
    setCheckedStateAccessType(finalArrAccessType);
  };

  useEffect(() => {
    if (rolesByEmailUser && rolesBySignatureProfile) {
      setDefaultCheckedValuesSignatureProfile();
      setDefaultCheckedValuesBoveda();
      setDefaultCheckedValuesContrato();
      setDefaultCheckedValuesHelpDesk();
      setDefaultCheckedValuesAccessType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesByEmailUser, rolesBySignatureProfile]);

  const handleCheckedSuperAdministrator = (e) => {
    setCheckedSuperAdministrator(e.target.checked);
    setCheckboxDisabled(e.target.checked);
    let arrBovedaCopy = [...checkedStateBoveda];
    let arrContratoCopy = [...checkedStateContrato];
    let arrHelpDeskCopy = [...checkedStateHelpDesk];
    arrBovedaCopy.map((item) => (item.checkedValue = false));
    arrContratoCopy.map((item) => (item.checkedValue = false));
    arrHelpDeskCopy.map((item) => (item.checkedValue = false));
  };

  const handleContratoCheckedState = (itemContrato, e) => {
    const { checked } = e.target;
    let arrContratoCopy = [...checkedStateContrato];
    let itemIndex = arrContratoCopy.findIndex(
      (item) => item.key === itemContrato.key
    );
    arrContratoCopy.map((item) => (item.checkedValue = false));
    arrContratoCopy[itemIndex].checkedValue = checked;
    setCheckedStateContrato(arrContratoCopy);
  };

  const handleHelpDeskCheckedState = (itemHelpDesk, e) => {
    const { checked } = e.target;
    let arrHelpDeskCopy = [...checkedStateHelpDesk];
    let itemIndex = arrHelpDeskCopy.findIndex(
      (item) => item.key === itemHelpDesk.key
    );
    arrHelpDeskCopy.map((item) => (item.checkedValue = false));
    arrHelpDeskCopy[itemIndex].checkedValue = checked;
    setCheckedStateHelpDesk(arrHelpDeskCopy);
  };

  const handleBovedaCheckedState = (itemBoveda, e) => {
    const { checked } = e.target;
    let arrBovedaCopy = [...checkedStateBoveda];
    let itemIndex = arrBovedaCopy.findIndex(
      (item) => item.key === itemBoveda.key
    );
    arrBovedaCopy.map((item) => (item.checkedValue = false));
    arrBovedaCopy[itemIndex].checkedValue = checked;
    setCheckedStateBoveda(arrBovedaCopy);
  };

  const handleProfileCheckedState = (position) => {
    const updatedProfileCheckedState = checkedStateProfiles.map(
      (profile, index) =>
        index === position
          ? { ...profile, checkedValue: !profile.checkedValue }
          : { ...profile }
    );
    setCheckedStateProfiles(updatedProfileCheckedState);
  };

  /**
   * @function handleNoPasswordChange
   * @description Maneja el cambio del checkbox de sin contraseña, mostrando confirmación al desactivar
   * @param {Object} itemAccessType - Tipo de acceso
   * @param {Event} e - Evento del checkbox
   * @returns {void}
   */
  const handleNoPasswordChange = (itemAccessType, e) => {
    const { checked } = e.target;
    const itemIndex = checkedStateAccessType.findIndex(
      (item) => item.key === itemAccessType.key
    );

    const currentValue = checkedStateAccessType[itemIndex].checkedValue;
    const newValue = checked;

    // Case 1: When ACTIVATING (passwordless)
    if (newValue && !currentValue) {
      setPendingNoPasswordChange({
        index: itemIndex,
        value: newValue,
        isActivating: true,
        isPendingOnboarding: false
      });
      setShowNoPasswordConfirm(true);
      return;
    }

    // Case 2: When DEACTIVATING
    if (!newValue && currentValue) {
      // Check if the user has showBtnReactive (needs onboarding)
      const isPendingOnboarding = selectedUser?.showBtnReactive === true;

      setPendingNoPasswordChange({
        index: itemIndex,
        value: newValue,
        isActivating: false,
        isPendingOnboarding
      });
      setShowNoPasswordConfirm(true);
      return;
    }

    // Default case: direct change without confirmation (should not reach here)
    const updatedAccessTypes = checkedStateAccessType.map((item, index) => ({
      ...item,
      checkedValue: index === itemIndex ? newValue : false
    }));
    setCheckedStateAccessType(updatedAccessTypes);
  };

  /**
   * @function handleNoPasswordConfirmClose
   * @description Cierra el modal de confirmación sin realizar cambios
   * @returns {void}
   */
  const handleNoPasswordConfirmClose = () => {
    setShowNoPasswordConfirm(false);
    setPendingNoPasswordChange(null);
  };

  /**
   * @function handleNoPasswordConfirmSubmit
   * @description Confirma la desactivación de "sin contraseña"
   * @returns {void}
   */
const handleNoPasswordConfirmSubmit = () => {
  if (!pendingNoPasswordChange) return

  const { index, value, isPendingOnboarding } = pendingNoPasswordChange

  const updatedAccessTypes = checkedStateAccessType.map((item, i) => ({
    ...item,
    checkedValue: i === index ? value : false
  }))
  setCheckedStateAccessType(updatedAccessTypes)

  if (isPendingOnboarding) {
    setPendingActions((prev) => ({
      ...prev,
      resendInvitation: true
    }))
  }

  setShowNoPasswordConfirm(false)
  setPendingNoPasswordChange(null)
}


  const handleSaveRolesAndProfilesData = async () => {
  toggleLoadingRequesting(true)

  try {
    if (pendingActions.resendInvitation) {
      const userInvitedService = new UserInvitedService(
        process.env.REACT_APP_MIFIRMA_API
      )

      await userInvitedService.resendInvitation(
        token,
        selectedUser.email
      )
    }

    const selectedRoles = [];
    if (checkedSuperAdministrator) {
      selectedRoles.push({
        role: 'hibouBasic',
        key: process.env.REACT_APP_ADMIN,
      });
    } else {
      selectedRoles.push({
        role: 'hibouBasic',
        key: process.env.REACT_APP_COLABORATOR,
      });
    }
    const selectedContractId = checkedStateContrato
      .filter((contract) => contract.checkedValue)
      .reduce(
        (defaultValue, obj) =>
          obj
            ? { role: 'hibouDigitalContract', key: obj.key }
            : { role: 'hibouDigitalContract', key: defaultValue },
        {
          role: 'hibouDigitalContract',
          key: process.env.REACT_APP_NOT_ACCESS_DIGITAL_CONTRACT,
        }
      );

    const selectedBovedaId = checkedStateBoveda
      .filter((boveda) => boveda.checkedValue)
      .reduce(
        (defaultValue, obj) =>
          obj
            ? { role: 'hibouDigitalVault', key: obj.key, id: obj.id }
            : { role: 'hibouDigitalVault', key: defaultValue, id: obj.id },
        {
          role: 'hibouDigitalVault',
          key: process.env.REACT_APP_NOT_ACCESS_DIGITAL_VAULT,
        }
      );

    const selectedHelpDeskId = checkedStateHelpDesk
      .filter((helpDesk) => helpDesk.checkedValue)
      .reduce(
        (defaultValue, obj) =>
          obj
            ? { role: 'hibouHelpDesk', key: obj.key }
            : { role: 'hibouHelpDesk', key: defaultValue },
        { role: 'hibouHelpDesk', key: null }
      );

    checkedSuperAdministrator
      ? selectedRoles.push(
        {
          role: 'hibouDigitalContract',
          key: process.env.REACT_APP_ADMIN_DIGITAL_CONTRACT,
        },
        {
          role: 'hibouDigitalVault',
          key: process.env.REACT_APP_ADMIN_DIGITAL_VAULT,
        },
        {
          role: 'hibouHelpDesk',
          key: process.env.REACT_APP_HELPDESK_VALIDATOR,
        }
      )
      : selectedRoles.push(
        selectedContractId,
        selectedBovedaId,
        selectedHelpDeskId
      );

    const filteredNewRoles = checkedStateProfiles.filter(
      (profile, index) =>
        profile.id === checkedStateProfilesOrg[index].id &&
        profile.checkedValue !==
          checkedStateProfilesOrg[index].checkedValue
    );

    const userId =
      rolesByEmailUser.signaturerProfiles.length > 0
        ? rolesByEmailUser.signaturerProfiles[0].userId
        : rolesByEmailUser.userId

    const selectedProfiles = filteredNewRoles.map((profile) => ({
      active: profile.checkedValue,
      userId,
      signatureProfileId: profile.id
    }));

    if (
      rolesBySignatureProfile.rolesAccessType &&
      rolesBySignatureProfile.rolesAccessType.length > 0
    ) {
      const accessTypeGroupName =
        rolesBySignatureProfile.rolesAccessType[0].groupName

      checkedStateAccessType.forEach((accessType) => {
        selectedRoles.push({
          role: accessTypeGroupName,
          key: accessType.key,
          value: accessType.checkedValue === true
        });
      });
    }

    const body = {
      email: selectedUser.email,
      rolesIds: selectedRoles,
      signatureProfiles: selectedProfiles,
      emailAdmin,
      firstName: selectedUser.firstName,
      firstLastName: selectedUser.firstLastName,
      secondLastName: selectedUser.secondLastName,
    };

    await saveRolesAndProfilesForUser(token, body)
    setPendingActions({ resendInvitation: false })

    toggleCompletedRequesting(true)
  } catch (error) {
    console.error(error)
    toggleErrorRequesting(true)
  } finally {
    toggleLoadingRequesting(false)
  }
};

  const isMobile = useMediaQuery('(max-width:560px');

  return (
    <div className='userAdministrationRoleAssignView-wrapper'>
      <>
        <header className='userAdministrationRoleAssignView-header'>
          <SubtitlePageHLPure
            subtitle={
              selectedUser.firstName !== '' ||
                (selectedUser.firstName !== null &&
                  selectedUser.firstLastName !== '') ||
                selectedUser.secondLastName !== ''
                ? `${t('userAdministrationView.title.roles.to')} ${selectedUser.name
                }`
                : t('userAdministrationView.roleAssignTitle')
            }
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow
            altCustomImg={'Empresa'}
            informationIcon={false}
            justShowImg
            openTooltipDescription={false}
          />
        </header>
        <section className='userAdministrationRoleAssignView-body'>
          <div className='userAdministrationRoleAssignView-form'>
            <div style={{ display: 'inline-flex' }}>
              <CheckBoxHLPure
                labelCheckBox={t('userAdministrationView.super.administrator')}
                checkedState={checkedSuperAdministrator}
                onChangeHandler={(e) => handleCheckedSuperAdministrator(e)}
                tooltipShow
                titleTooltip={t('userAdministrationView.super.administrator')}
                descriptionTooltip={t(
                  'userAdministrationRoleAssign-superUserTooltip'
                )}
                positionTooltip={isMobile ? 'top' : 'right'}
                informationIcon
                idCheckBox={'Super administrador govo.digital'}
              />{' '}
            </div>
          </div>
          <div className='userAdministrationRoleAssignView-checks'>
            <div className='userAdministrationRoleAssignView-contract'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.digital.library')}</label>
                <TooltipHLPure
                  titleTooltip={t('userAdministrationView.digital.library')}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-digitalLibraryTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                  styleTooltipIcon='tooltipHLPure-icon-container'
                />
              </div>

              {checkedStateContrato &&
                checkedStateContrato.map((rolContrato, index) => {
                  return (
                    <CheckBoxHLPure
                      key={index}
                      disabled={checkboxDisabled}
                      labelCheckBox={t(`userRoles.${rolContrato.key}`, {
                        defaultValue: rolContrato.name
                      })}
                      checkedState={
                        checkedSuperAdministrator
                          ? false
                          : rolContrato.checkedValue
                      }
                      onChangeHandler={(e) =>
                        handleContratoCheckedState(rolContrato, e)
                      }
                      idCheckBox={rolContrato.id}
                    />
                  );
                })}
            </div>
            <div className='userAdministrationRoleAssignView-boveda'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.digital.vault')}</label>
                <TooltipHLPure
                  titleTooltip={t('userAdministrationView.digital.vault')}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-bovedaTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                  styleTooltipIcon='tooltipHLPure-icon-container'
                />
              </div>
              {checkedStateBoveda &&
                checkedStateBoveda.map((rolBoveda, index) => {
                  return (
                    <CheckBoxHLPure
                      key={rolBoveda.key}
                      disabled={checkboxDisabled}
                      labelCheckBox={t(`userRoles.${rolBoveda.key}`, {
                        defaultValue: rolBoveda.name
                      })}
                      checkedState={
                        checkedSuperAdministrator
                          ? false
                          : rolBoveda.checkedValue
                      }
                      onChangeHandler={(e) =>
                        handleBovedaCheckedState(rolBoveda, e)
                      }
                      idCheckBox={rolBoveda.id}
                    />
                  );
                })}
            </div>
            <div className='userAdministrationRoleAssignView-boveda'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('app.action.helpDesk')}</label>
                <TooltipHLPure
                  titleTooltip={t('app.action.helpDesk')}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-helpDeskTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                  styleTooltipIcon='tooltipHLPure-icon-container'
                />
              </div>
              {checkedStateHelpDesk &&
                checkedStateHelpDesk.map((rolHelpDesk, index) => {
                  return (
                    <CheckBoxHLPure
                      key={index}
                      disabled={checkboxDisabled}
                      labelCheckBox={t(`userRoles.${rolHelpDesk.key}`, {
                        defaultValue: rolHelpDesk.name
                      })}
                      checkedState={
                        checkedSuperAdministrator
                          ? false
                          : rolHelpDesk.checkedValue
                      }
                      onChangeHandler={(e) =>
                        handleHelpDeskCheckedState(rolHelpDesk, e)
                      }
                      idCheckBox={rolHelpDesk.id}
                    />
                  );
                })}
            </div>
            <div className='userAdministrationRoleAssignView-profiles'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.signatures.profile')}</label>
                <TooltipHLPure
                  titleTooltip={'Asignar Perfiles'}
                  descriptionTooltip={t(
                    'userAdministrationRoleAssign-profilesTooltip'
                  )}
                  positionTooltip={isMobile ? 'top' : 'right'}
                  informationIcon
                  styleTooltipIcon='tooltipHLPure-icon-container'
                />
              </div>
              {checkedStateProfiles &&
                checkedStateProfiles.length &&
                checkedStateProfiles.map((profile, index) => {
                  return (
                    <CheckBoxHLPure
                      key={index}
                      labelCheckBox={profile.name}
                      checkedState={profile.checkedValue}
                      onChangeHandler={() => handleProfileCheckedState(index)}
                      idCheckBox={profile.id}
                    />
                  );
                })}
            </div>

            <div className='userAdministrationRoleAssignView-accessType'>
              <div className='userAdministrationRoleAssignView-titleToolTips'>
                <label>{t('userAdministrationView.access.type')}</label>
              </div>
              {checkedStateAccessType &&
                checkedStateAccessType.map((accessType, index) => {
                  return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <CheckBoxHLPure
                        key={index}
                        labelCheckBox={t(`userRoles.${accessType.key}`, {
                          defaultValue: accessType.name
                        })}
                        checkedState={accessType.checkedValue}
                        onChangeHandler={(e) =>
                          handleNoPasswordChange(accessType, e)
                        }
                        idCheckBox={accessType.id}
                      />
                      <TooltipHLPure
                        titleTooltip={t('userAdministrationView.access.type')}
                        descriptionTooltip={t('userAdministrationView.access.type.tooltip')}
                        positionTooltip={isMobile ? 'top' : 'right'}
                        informationIcon
                        styleTooltipIcon='tooltipHLPure-icon-container'
                      />
                    </div>
                  );
                })}
            </div>
          </div>
          <div className='userAdministrationRoleAssignView-btnGroup'>
            <div className='userAdministrationRoleAssignView-spaceBtns'>
              <ButtonHLPure
                nameBtn={t('button.return')}
                onClickBtn={
                  showDetailComponent
                    ? toggleShowDetailComponent
                    : hideShowDetails
                }
              />
            </div>
            <ButtonHLPure
              primary
              nameBtn={t('button.save')}
              onClickBtn={handleSaveRolesAndProfilesData}
            />
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              showCompletedRequesting={showCompletedRequesting}
              showErrorRequesting={showErrorRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}
              toggleCompletedRequesting={toggleCompleteCloseDialog}
              toggleErrorRequesting={toggleErrorRequesting}
              message={message}
              showConfirm={showNoPasswordConfirm}
              confirmTitle={
                pendingNoPasswordChange?.isActivating
                  ? t('userAdministrationView.noPassword.activate.confirm.title')
                  : pendingNoPasswordChange?.isPendingOnboarding
                    ? t('userAdministrationView.pendingOnboarding.title')
                    : t('userAdministrationView.noPassword.deactivate.confirm.title')
              }
              confirmMessage={
                pendingNoPasswordChange?.isActivating
                  ? t('userAdministrationView.noPassword.activate.confirm.message')
                  : pendingNoPasswordChange?.isPendingOnboarding
                    ? t('userAdministrationView.pendingOnboarding.message')
                    : t('userAdministrationView.noPassword.deactivate.confirm.message')
              }
              handleConfirmDeleteFlowClose={handleNoPasswordConfirmClose}
              handleConfirmDeleteFlowSubmit={handleNoPasswordConfirmSubmit}
              labelCancelConfirmation={t('button.cancel')}
              labelSubmitConfirmation={t('button.confirm')}
            />
          </div>
        </section>
      </>
    </div>
  );
};

export default UserAdministrationRoleAssignView;
